import myaxios from '../utils/myaxios'


export function wellPacket(data) {
    return myaxios({
        url: '/manager/packet/well-packet',
        data,
        method: 'post',
    })

}

export function getAgentPacket(data) {
    return myaxios({
        url: '/manager/ag-pac/gt-apet',
        data,
        method: 'post',
    })

}

export function removePacket(data) {
    return myaxios({
        url: '/manager/packet/deletePacket',
        data,
        method: 'post'
    })
}

export function importPacket(data) {
    return myaxios({
        url: '/manager/packet/import-packet',
        data,
        method: 'post'
    })
}

export function addPacket(data) {
    return myaxios({
        url: '/manager/packet/savePacket',
        data,
        method: 'post'
    })
}

/**
 * 分配套餐
 * @param data
 * @returns {AxiosPromise}
 */
export function allocPacket(data) {
    return myaxios({
        url: "/manager/packet/alloc-packet",
        headers:{
            "Content-Type": "multipart/form-data"
        },
        data,
        method: 'post'
    })
}

export function allocPacketText(data) {
    return myaxios({
        url: '/manager/packet/allocPacketText',
        data,
        method: 'post'
    })
}

export function needsImortPac(data) {
    return myaxios({
        url: '/manager/ag-pac/needs-imort-pac',
        data,
        method: 'post'
    })
}

export function loadPacket(data) {
    return myaxios({
        url: '/manager/packet/load-packet',
        params: data,
    })
}

export function getPackets(data) {
    return myaxios({
        url: '/manager/packet/get-packets',
        data,
        method: 'post'
    })
}

export function unsubscribe(data) {
    return myaxios({
        url: '/manager/package/Unsubscribe',
        data,
        method: 'post'
    })
}


export function expireTime(data) {
    return myaxios({
        url: '/manager/pac/expireTime',
        data,
        method: 'post'
    })
}

export function upd_packageTime(data) {
    return myaxios({
        url: '/manager/package/upd_packageTime',
        data,
        method: 'post'
    })
}

export function join_package(data) {
    return myaxios({
        url: '/manager/package/join_package',
        data,
        method: 'post'
    })
}

export function imag_pac(data) {
    return myaxios({
        url: '/manager/ag-pac/imag-pac',
        data,
        method: 'post'
    })
}

/**
 * @description 复制套餐
 * @author TAO WANG
 * @date 14:46 2023/12/15 0015
 */
export function copyPacket(data) {
    return myaxios({
        url: '/manager/packet/copyPacket',
        data,
        method:'post'
    })
}
